import { render, staticRenderFns } from "./lang-tabs.vue?vue&type=template&id=6b9f6916&"
import script from "./lang-tabs.vue?vue&type=script&lang=js&"
export * from "./lang-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports